<template>
  <div>
    <van-popup v-model="show" round :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <div class="title">提现银行卡信息</div>
        <div class="area">
          <div class="row">
            <div class="key">主体类型</div>
            <div class="value">{{ info.regMerType || '-'}}</div>
          </div>
          <div class="row">
            <div class="key">商户名称</div>
            <div class="value">{{ info.shopName || '-'}}</div>
          </div>
          <div class="row">
            <div class="key">提现银行卡</div>
            <div class="value">{{ info.bankNo || '-'}}</div>
          </div>
          <div class="row">
            <div class="key">开户银行全称</div>
            <div class="value">{{ info.bankName || '-' }}</div>
          </div>
        </div>
        <van-button 
          class="btn" 
          color="linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%)" 
          type="primary" 
          round 
          size="small" 
          block
          @click="show = false"
        >
          关闭
        </van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
  export default {
    props: {
    },
    data() {
      return {
        show: false,
        info: {
          regMerType: '',
          shopName: '',
          bankNo: '',
          bankName: ''
        }
      }
    },
    methods: {
      open(info) {
        if (info) {
          this.info = info
        }
        this.show = true
      },
      withdraw() {}
    }
  }
</script>

<style lang="stylus" scoped>
  .content {
    width: 72vw;
    padding: 20px;
    color: #333333;
    .title {
      color: #333333;
      font-size: 17px;
      text-align: center;
      margin-bottom: 15px;
    }
    .area {
      .row {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        .key {
          width: 100px;
          color: #666666;
        }
        .value {
          flex: 1;
          text-align: right;
        }
      }
    }
    .btn {
      margin-top: 20px;
    }
    .active {
      color: #fff;
      background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
    }
  }
</style>